import type { NodeViewProps } from '@tiptap/react';
import { useResizeObserver } from '@mantine/hooks';
import { NodeViewWrapper } from '@tiptap/react';
import clsx from 'clsx';
import { useMemo } from 'react';
import { dynamicImageUrl, isObjectUrl } from '@_/utils-frontend';

export function EditableDocumentImage({ editor, HTMLAttributes, node, selected }: NodeViewProps) {
  const { draggable } = node.type.spec;
  const { dimensions, src } = node.attrs;

  const [targetRef, { width: parentWidth }] = useResizeObserver();

  const maxParentWidth = Math.min(dimensions?.width || 0, parentWidth || 0);

  const srcSet = useMemo(() => {
    return dimensions?.width && parentWidth
      ? [1, 2, 3].map(dpr => {
          const srcWidth = Math.min(parentWidth * dpr, dimensions.width);
          const url = dynamicImageUrl(src, { width: srcWidth });
          return `${url} ${srcWidth}w`;
        })
      : undefined;
  }, [dimensions, parentWidth, src]);

  return (
    <NodeViewWrapper>
      <div ref={targetRef}>
        <img
          {...HTMLAttributes}
          ref={targetRef}
          className={clsx('mx-auto', selected && 'outline-4 outline-blue-600')}
          data-drag-handle={editor.isEditable && draggable ? true : undefined}
          data-dimensions={`${dimensions?.width},${dimensions?.height}`}
          data-image-id={node.attrs.imageId}
          draggable={editor.isEditable && draggable}
          sizes={
            !isObjectUrl(src) && maxParentWidth
              ? `(max-width: ${maxParentWidth}px) 100%, ${maxParentWidth}px`
              : undefined
          }
          src={isObjectUrl(src) ? src : undefined}
          srcSet={!isObjectUrl(src) ? srcSet?.join(',') : undefined}
        />
      </div>
    </NodeViewWrapper>
  );
}
